/* eslint-disable max-nested-callbacks */
/* eslint-disable consistent-return */
import { Accordion, Card, DialogContent, Dialog, Grid, Icon, Stack, Typography, CardContent, Button, Box } from '@mui/material'
import SimpleTabList from 'components/list/SimpleTabList'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { push } from '@lagunovsky/redux-react-router'
import { flattenDeep, groupBy, isNil, keys, orderBy, includes, capitalize, pick, values, compact, isEmpty, uniq, isUndefined, maxBy, truncate, omit } from 'lodash'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import 'moment/locale/fr'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import useActions from 'utils/customHook/useActions'
import useBoolean from 'utils/customHook/useBoolean'
import { formatData } from 'utils/ExportDataUtil'
import { getI18nTitleDataLength, normalizeString } from 'utils/StringUtil'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import Input from '../../../components/forms/Input'
import CartographyPanel from '../../../components/map/CartographyPanel'
import ImportXmlQualityPopup from '../../../import/components/popup/ImportXmlQualityPopup'
import { getDate } from '../../../utils/DateUtil'
import { hasValue } from '../../../utils/NumberUtil'
import { getLabel } from '../../../utils/StoreUtils'
import { getCampaignPeriodTitle, getMarkerIcon, getPlanningPeriodTitle } from '../../utils/CampaignUtils'
import DtoOperation from 'quality/dto/operation/DtoOperation'
import DtoAnalysisLight from 'quality/dto/analyse/DtoAnalysisLight'
import ExportFileModal from 'components/modal/ExportFileModal'
import ExportAction from 'export/actions/ExportAction'
import { getLocalizationLabel, getLocalizationPicto, getResultFormat } from 'utils/AnalyseUtils'
import { AccordionTitle } from 'components/styled/Accordions'
import { PASTEL_COLOR } from 'utils/constants/ColorTheme'
import DtoEnvironmentalConditionLight from 'quality/dto/DtoEnvironmentalConditionLight'
import { CardTable, NewTable, SORT, WrapperAccordionDetails } from 'components/datatable/NewTable'
import useListIndexed from 'utils/customHook/useListIndexed'
import { nbPerPageLabel } from 'referencial/constants/ReferencialConstants'
import AnalysisAction from 'quality/actions/AnalysisAction'
import OperationAction from 'quality/actions/OperationAction'
import QualityAction from 'quality/actions/QualityAction'
import useAbortController from 'utils/customHook/useAbortController'
import ProgressBar from 'components/progress/ProgressBar'
import { CardTitle } from 'components/card/NewCard'
import OperationPCStepper, { getAnalysisFromParametersPlan } from 'quality/components/operation/components/stepper/OperationPCStepper'
import AnalysisStepper from 'quality/components/operation/components/stepper/AnalysisStepper'
import ToastrAction from 'toastr/actions/ToastrAction'
import { hybridSearch } from 'utils/SearchUtil'
import { NoDataPanel } from 'components/card/NoDataCard'
import { SHOW_INSEE_CODE, SHOW_SANDRE_CODE } from 'account/constants/AccountSettingsConstants'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import { authorizeContributors } from 'utils/HabilitationUtil'
import Select from 'components/forms/Select'
import { campaignShape } from 'campaign/shapes/CampaignShapes'
import { getTextColorByBackground } from 'utils/ColorUtil'
import { useOutletContext } from 'react-router'
import { QUALITY_CAMPAIGN_REQUEST_CONSTANTS } from 'campaign/constants/CampaignConstants'
import { formatedFileName } from 'utils/FileUtils'
import CampaignProgress from './CampaignProgress'
import { ANALYSIS } from 'quality/components/operation/constants/OperationDescriptionConstants'

const moment = extendMoment(Moment)
moment.locale('fr')

const LIST = 'LIST'
const CARTO = 'CARTO'
const UNKNOWN_VALUE = '0'
const NOT_SPECIFIED_PRODUCER = -1

const formatTooltip = (analyse, neededAnalyse) => {
    if (isNil(analyse)) return i18n.AnalysisNotMade

    const support = isNil(neededAnalyse.supportCode) || neededAnalyse.supportCode === UNKNOWN_VALUE || `${analyse.support}` === neededAnalyse.supportCode ? '' : i18n.incorrectSupport
    const fraction = isNil(neededAnalyse.fractionCode) || neededAnalyse.fractionCode === UNKNOWN_VALUE || analyse.fraction === neededAnalyse.fractionCode ? '' : i18n.incorrectFraction
    const unit = isNil(neededAnalyse.unitCode) || neededAnalyse.unitCode === UNKNOWN_VALUE || analyse.unit === neededAnalyse.unitCode ? '' : i18n.incorrectUnit
    const localization = (neededAnalyse.placeCode ?? UNKNOWN_VALUE) === UNKNOWN_VALUE || analyse.localization === neededAnalyse.placeCode ? '' : i18n.incorrectPlace

    return (
        <span style={{ whiteSpace: 'pre-wrap' }}>
            {[unit, support, fraction, localization].filter(v => !!v).join('\n')}
        </span>
    )
}

const getInfo = (isMissing, isPresent) => {
    if (isMissing && isPresent) return { value: (<Icon sx={{ color: 'orange' }}>error_outlined</Icon>), sortValue: 1, label: i18n.incomplete }
    if (!isPresent || isMissing) return { value: (<Icon sx={{ color: 'red' }}>close</Icon>), sortValue: 0, label: i18n.no }
    return { value: (<Icon sx={{ color: 'green' }}>check</Icon>), sortValue: 2, label: i18n.yes }
}

const OperationAccordion = ({
    neededAnalysis = [],
    operation = {},
    analysis = [],
    searchValue = '',
    defaultExpanded = false,
    onAddAnalysis,
}) => {
    const dispatch = useDispatch()

    const {
        parameters,
        supports,
        units,
        fractions,
    } = useSelector(store => ({
        parameters: store.ParameterReducer.parameters,
        supports: store.SupportReducer.supports,
        units: store.UnitReducer.units,
        fractions: store.FractionReducer.fractions,
    }), shallowEqual)

    const indexedParameters = useListIndexed(parameters, 'code')
    const indexedSupports = useListIndexed(supports)
    const indexedFractions = useListIndexed(fractions)
    const indexedUnits = useListIndexed(units)

    const formattedSearchValue = normalizeString(searchValue)

    const neededParameterCodes = new Set(neededAnalysis.map(na => na.parameterCode))
    const formattedResults = orderBy(analysis.filter(a => neededParameterCodes.has(a.parameter)), 'parameter').map(a => {
        const labelParameter = indexedParameters[a.parameter]?.labelWithCode
        const labelUnit = indexedUnits[a.unit]?.symbolWithCode
        const labelSupport = indexedSupports[a.support]?.labelWithCode
        const labelFraction = indexedFractions[a.fraction]?.labelWithCode

        return {
            parameter: labelParameter,
            result: getResultFormat(a),
            unit: labelUnit,
            support: labelSupport,
            fraction: labelFraction,
            localization: getLocalizationPicto(a.localization),

            searchValue: [labelParameter, labelUnit, labelSupport, labelFraction, getLocalizationLabel(a.localization)].map((s = '') => normalizeString(s)).join('#'),
        }
    })
    const filteredResults = formattedResults.filter(r => r.searchValue.includes(formattedSearchValue))

    return (
        <Accordion defaultExpanded={defaultExpanded}>
            <AccordionTitle
                title={`${i18n.operation} ${i18n.fromDate} ${getDate(operation.date)}`}
                actions={compact([
                    onAddAnalysis && {
                        icon: 'add',
                        color: 'white',
                        tooltip: i18n.newAnalysis,
                        onClick: onAddAnalysis,
                    },
                    {
                        icon: 'launch',
                        color: 'white',
                        tooltip: i18n.accessToOperation,
                        onClick: () => dispatch(push(`/station/quality/${operation.qualitometer}/operation/${operation.id}?tab=${ANALYSIS}`)),
                    },
                ])}
            />
            <NewTable
                rows={filteredResults}
                headers={['parameter', 'result', 'unit', 'support', 'fraction', 'localization']}
                defaultSort={{ column: 'parameter', direction: SORT.ASC }}
                WrapperComponent={WrapperAccordionDetails}
            />
        </Accordion>
    )
}

OperationAccordion.propTypes = {
    neededAnalysis: PropTypes.arrayOf(PropTypes.shape({})),
    operation: PropTypes.instanceOf(DtoOperation),
    analysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    searchValue: PropTypes.string,
    defaultExpanded: PropTypes.bool,
    onAddAnalysis: PropTypes.func,
}

const PopinOperation = ({
    isOpen = false,
    closePopin = () => {},
    plannings = [],
    planningsProgress = [],
    stationId,
    planningId,
    campaign,
}) => {
    const {
        controllerRef,
        initController,
    } = useAbortController()

    const {
        edilaboFiles,
    } = useOutletContext()

    const {
        qualitometers,
        campaignPlanningsExceptions,
        campaignStations,
        campaignParameters,
        parametersIndex,
        supportsIndex,
        unitsIndex,
        fractions,
        citiesIndex,
        allPoints,
        campaignPlannings,
    } = useSelector(store => ({
        allPoints: store.QualityReducer.allPoints,
        campaignPlannings: store.CampaignReducer.campaignPlannings,
        qualitometers: store.QualityReducer.qualitometersLight,
        campaignPlanningsExceptions: store.CampaignReducer.campaignPlanningsExceptions,
        campaignStations: store.CampaignReducer.campaignStations,
        campaignParameters: store.CampaignReducer.campaignParameters,
        parametersIndex: store.ParameterReducer.parametersIndex,
        supportsIndex: store.SupportReducer.supportsIndex,
        unitsIndex: store.UnitReducer.unitsIndex,
        fractions: store.FractionReducer.fractions,
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const indexedFractions = useListIndexed(fractions)

    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)

    const dispatch = useDispatch()

    const [searchValue, setSearchValue] = useState('')
    const {
        value: isLoading,
        setTrue: onLoadStart,
        setFalse: onLoadEnd,
    } = useBoolean(true)

    const {
        value: isExportOpen,
        setTrue: setExportOpen,
        setFalse: setExportClosed,
    } = useBoolean(false)

    const [analysis, setAnalysis] = useState([])
    const [operations, setOperations] = useState([])
    const [openModalOperationCreation, setOpenModalOperationCreation] = useState(false)
    const [analysisStepper, setAnalysisStepper] = useState() // { operation, sampleId, defaultAnalysis } : ajout d'analyses sur une opération existante

    const qualitometer = qualitometers.find(q => q.id === stationId)
    const {
        startDate,
        endDate,
        parametersPlan = [],
    } = plannings.find(cp => cp.id === planningId) ?? {}

    const campaignPlanningExceptions = campaignPlanningsExceptions.filter(({ planningId: id, stationsPlan }) => id === planningId && includes(stationsPlan, campaignStations.find(({ stationId: idStationCampaign }) => idStationCampaign === stationId)?.id))
    const [parametersToAdd, parametersToDelete] = campaignPlanningExceptions.reduce(([toAdd, toDelete], exception) => (
        [
            [...toAdd, ...exception.parametersToAddPlan],
            [...toDelete, ...exception.parametersToDeletePlan],
        ]
    ), [[], []])

    const {
        missingAnalysis = [],
    } = planningsProgress.find(pp => pp.id === planningId)?.stationsProgress.find(sp => sp.id === stationId) ?? {}

    const newParametersPlan = [
        ...parametersPlan.filter(({ id }) => !includes(parametersToDelete, id)),
        ...campaignParameters.filter(({ id }) => includes(parametersToAdd, id)),
    ]

    useEffect(() => {
        setAnalysis([])
        setOperations([])

        if (!isOpen) return

        initController()
        onLoadStart()

        Promise.all([
            OperationAction.getOperations(stationId, controllerRef.current.signal)
                .then((list = []) => setOperations(list)),
            AnalysisAction.getAnalysis({ stations: [stationId], campaign: campaign.id, startDate, endDate, lightMode: true }, controllerRef.current.signal)
                .then((list = []) => setAnalysis(p => [...p, ...list.map(a => new DtoAnalysisLight(a))])),
            QualityAction.getEnvironmentalCondition({ stations: [stationId], campaign: campaign.id, startDate, endDate }, controllerRef.current.signal)
                .then((list = []) => setAnalysis(p => [...p, ...list.map(e => new DtoEnvironmentalConditionLight(e))])),
        ]).finally(onLoadEnd)

        // eslint-disable-next-line consistent-return
        return () => {
            controllerRef.current.abort()
        }
    }, [isOpen])

    const orderedOperations = orderBy(
        operations
            .map(op => ({ ...op, date: moment(op.date).startOf('day').valueOf() }))
            .filter(o => o.campaign === campaign.id && startDate <= o.date && o.date <= endDate),
        'date',
    )

    const groupAnalysis = groupBy(analysis, 'operation')

    // saisie des résultats de cette planification sur une opération déjà existante (ex : plusieurs labos qui interviennent sur la même opération)
    const onAddAnalysis = operationId => {
        const operation = operations.find(({ id }) => id === operationId)
        if (!operation) return
        const operationAnalysis = groupAnalysis[operationId] ?? []
        const presentParameters = new Set(operationAnalysis.map(a => a.parameter))
        const planning = plannings.find(({ id }) => id === planningId)
        const labo = parseInt(planning?.producer ?? campaign.recipientCode)
        const defaultAnalysis = getAnalysisFromParametersPlan(newParametersPlan.filter(({ parameterCode }) => !presentParameters.has(parameterCode)))
            .map(a => ({ ...a, labo: isNaN(labo) ? undefined : labo }))

        const sampleId = operationAnalysis.find(a => !isNil(a.sample))?.sample
        const promiseSampleId = isNil(sampleId) ? OperationAction.promiseSample(stationId, operationId).then(sample => sample?.id) : Promise.resolve(sampleId)
        promiseSampleId
            .then(id => setAnalysisStepper({ operation, sampleId: id, defaultAnalysis }))
            .catch(() => dispatch(ToastrAction.error(i18n.loadError)))
    }

    const city = qualitometer?.townCode ? citiesIndex[qualitometer?.townCode]?.name || '' : ''

    const exportNeededAnalysis = orderBy(newParametersPlan, 'parameterCode').map(na => {
        const {
            parameterCode,
            supportCode,
            unitCode,
            fractionCode,
            placeCode,
        } = na

        const isPresent = analysis.some(a => a.parameter === parameterCode)
        const isMissing = missingAnalysis.some(ma => (
            ma.parameter === parameterCode &&
            (ma.support === UNKNOWN_VALUE || ma.support === supportCode) &&
            (ma.fraction === UNKNOWN_VALUE || ma.fraction === fractionCode) &&
            (ma.unit === UNKNOWN_VALUE || ma.unit === unitCode) &&
            (ma.localization === UNKNOWN_VALUE || ma.localization === placeCode)
        ))

        const {
            label,
        } = getInfo(isMissing, isPresent)

        return {
            stationCode: { value: qualitometer?.code, cellType: 'string' },
            city,
            stationName: qualitometer?.name,
            id: na.id,
            parameterCode,
            parameter: parametersIndex[parameterCode]?.name,
            codeUnit: unitCode,
            unit: unitsIndex[unitCode]?.symbol,
            supportCode,
            support: supportsIndex[supportCode]?.name,
            fractionCode,
            fraction: indexedFractions[fractionCode]?.name,
            localization: getLocalizationLabel(placeCode),
            analyzedParameters: label,
        }
    })

    const exportMissingAnalysis = exportNeededAnalysis.filter(na => na.analyzedParameters !== i18n.yes)

    const formattedNeededAnalysis = orderBy(newParametersPlan, 'parameterCode').map(na => {
        const {
            parameterCode,
            supportCode,
            unitCode,
            fractionCode,
            placeCode,
        } = na

        const labelParameter = showSandreCode ? parametersIndex[parameterCode]?.labelWithCode : parametersIndex[parameterCode]?.name
        const labelUnit = showSandreCode ? unitsIndex[unitCode]?.symbolWithCode : unitsIndex[unitCode]?.symbol
        const labelSupport = showSandreCode ? supportsIndex[supportCode]?.labelWithCode : supportsIndex[supportCode]?.name
        const labelFraction = showSandreCode ? indexedFractions[fractionCode]?.labelWithCode : indexedFractions[fractionCode]?.name

        const analyse = analysis.find(a => a.parameter === parameterCode)
        const isPresent = !isNil(analyse)
        const isMissing = missingAnalysis.some(ma => (
            ma.parameter === parameterCode &&
            (ma.support === UNKNOWN_VALUE || ma.support === supportCode) &&
            (ma.fraction === UNKNOWN_VALUE || ma.fraction === fractionCode) &&
            (ma.unit === UNKNOWN_VALUE || ma.unit === unitCode) &&
            (ma.localization === UNKNOWN_VALUE || ma.localization === placeCode)
        ))

        const {
            value,
            sortValue,
        } = getInfo(isMissing, isPresent)

        return {
            validatedIcon: {
                value,
                sortValue,
                tooltip: isMissing ? formatTooltip(analyse, na) : undefined,
            },
            parameter: labelParameter,
            unit: labelUnit,
            support: labelSupport,
            fraction: labelFraction,
            localization: getLocalizationPicto(placeCode),

            searchValue: [labelParameter, labelUnit, labelSupport, labelFraction, getLocalizationLabel(placeCode)].map((s = '') => normalizeString(s)).join('#'),
        }
    })

    const nbValidated = formattedNeededAnalysis.reduce((nb, na) => na.validatedIcon.sortValue === 2 ? nb + 1 : nb, 0)
    const neededAnalysisColor = nbValidated >= newParametersPlan.length
        ? PASTEL_COLOR.green
        : nbValidated === 0
            ? PASTEL_COLOR.red
            : PASTEL_COLOR.orange

    const dialogTitle = <Typography variant='h5'>{`${getDate(startDate)} - ${getDate(endDate)}`}</Typography>
    // une même station peut être planifiée sur plusieurs lieux de prélèvement
    // (planning brut du store : dans `plannings`, stationsPlan contient des ids de qualitomètres et non de stations de campagne)
    const rawPlanning = campaignPlannings.find(({ id }) => id === planningId)
    const samplePointsLabel = uniq(compact(campaignStations
        .filter(cs => cs.stationId === stationId && (!rawPlanning || includes(rawPlanning.stationsPlan, cs.id)))
        .map(cs => {
            const samplePoint = allPoints.find(p => p.idQualitometer === stationId && p.idPoint === cs.samplePoint)
            return showSandreCode ? samplePoint?.displayLabel : samplePoint?.name
        }))).join(', ')
    const stationTitle = <Typography variant='h6'>{`[${qualitometer?.code ?? ''}] ${qualitometer?.name ?? ''}${city !== '' ? ` - ${city}` : ''}${samplePointsLabel ? ` - ${samplePointsLabel}` : ''}`}</Typography>

    return (
        <>
            <Dialog
                maxWidth='lg'
                fullWidth
                open={isOpen}
                slotProps={{
                    paper: {
                        sx: {
                            minHeight: '70vh',
                            maxHeight: '70vh',
                        },
                    },
                }}
            >
                <DefaultDialogTitle
                    title={<Box sx={{ whiteSpace: 'pre-line' }}>{dialogTitle}{stationTitle}</Box>}
                    onClose={closePopin}
                />
                <DialogContent style={{ paddingTop: 10 }}>
                    <Stack spacing={1}>
                        <Input
                            title={i18n.search}
                            value={searchValue}
                            onChange={setSearchValue}
                        />
                        <CardTable
                            title={i18n.neededAnalysis}
                            subTitle={`${nbValidated}/${newParametersPlan.length}`}
                            hideNbElements
                            color={neededAnalysisColor}
                            rows={formattedNeededAnalysis}
                            headers={[{ key: 'validatedIcon', value: '' }, 'parameter', 'unit', 'support', 'fraction', 'localization']}
                            defaultSort={{ column: 'validatedIcon', direction: SORT.ASC }}
                            actions={[{
                                icon: 'file_download',
                                color: getTextColorByBackground(neededAnalysisColor),
                                tooltip: i18n.export,
                                onClick: setExportOpen,
                            }]}
                        />
                        <Grid container spacing={0.5} >
                            {isLoading && (
                                <Grid size={12}>
                                    <ProgressBar indeterminate />
                                </Grid>
                            )}
                            {!isLoading && orderedOperations.map((operation, i) => (
                                <Grid key={operation.id} size={12}>
                                    <OperationAccordion
                                        neededAnalysis={newParametersPlan}
                                        operation={operation}
                                        analysis={groupAnalysis[operation.id]}
                                        searchValue={searchValue}
                                        defaultExpanded={i === 0}
                                        onAddAnalysis={() => onAddAnalysis(operation.id)}
                                    />
                                </Grid>
                            ))}
                            {!isLoading && orderedOperations.length === 0 && (
                                <>
                                    <Grid size={12}>
                                        <Card>
                                            <CardTitle
                                                title={i18n.noOperationsDuringThisPeriod}
                                                actions={[{
                                                    icon: 'add',
                                                    onClick: () => {
                                                        dispatch(QualityAction.fetchQualitometer(stationId, false)).then(() => {
                                                            setOpenModalOperationCreation(true)
                                                            closePopin()
                                                        })
                                                    },
                                                    tooltip: i18n.newOperation,
                                                }]}
                                            />
                                        </Card>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Stack>
                </DialogContent>
            </Dialog>
            <ExportFileModal
                open={isExportOpen}
                onClose={setExportClosed}
                data={compact([
                    {
                        name: i18n.neededAnalysis,
                        formats: [{
                            type: i18n.excelFile,
                            callback: () => {
                                dispatch(ExportAction.export(formatData(exportNeededAnalysis.length ? [
                                    { ...exportNeededAnalysis[0], headers: keys(omit(exportNeededAnalysis[0], 'id')) },
                                    ...exportNeededAnalysis.slice(1),
                                ] : []), 'xlsx', `${i18n.neededAnalysis} ${getDate(startDate)} - ${getDate(endDate)} : [${qualitometer?.code ?? ''}] ${qualitometer?.name ?? ''}${city !== '' ? ` - ${city}` : ''}`))
                            },
                        }, {
                            type: i18n.csvFile,
                            callback: () => {
                                dispatch(ExportAction.export(formatData(exportNeededAnalysis.length ? [
                                    { ...exportNeededAnalysis[0], headers: keys(omit(exportNeededAnalysis[0], 'id')) },
                                    ...exportNeededAnalysis.slice(1),
                                ] : []), 'csv', `${i18n.neededAnalysis} ${getDate(startDate)} - ${getDate(endDate)} : [${qualitometer?.code ?? ''}] ${qualitometer?.name ?? ''}${city !== '' ? ` - ${city}` : ''}`))
                            },
                        }, {
                            type: i18n.EDILABODAI,
                            callback: () => {
                                const lastFile = maxBy(edilaboFiles, 'updateDate')
                                const exportPath = lastFile ? lastFile.href.split('EXPORT/EDILABO/')[1].replace(lastFile.label, '') : ''
                                const samplerCode = hasValue(campaign.samplerCode) ? parseInt(campaign.samplerCode) : undefined
                                const recipientCode = hasValue(campaign.recipientCode) ? parseInt(campaign.recipientCode) : undefined
                                const getReceiver = () => {
                                    switch (campaign.requestType) {
                                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.SAMPLE_REQUEST:
                                            return samplerCode
                                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.ANALYSIS_REQUEST:
                                            return recipientCode
                                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.MIXED_REQUEST:
                                            return recipientCode || samplerCode
                                        default:
                                            return undefined
                                    }
                                }
                                dispatch(ExportAction.exportEDILABOPlanning({
                                    campaignId: campaign.id,
                                    exportPath,
                                    requestName: formatedFileName(truncate(
                                        `DAI-${moment(startDate).format('DD/MM/YYYY').slice(0, 2)}-${moment(endDate).format('DD/MM/YYYY').slice(0, 2)}-${moment(endDate).format('DD/MM/YYYY').slice(3)}${qualitometer?.code ? `-${qualitometer.code}` : ''}`,
                                        {
                                            length: 34,
                                            omission: '',
                                        },
                                    )),
                                    startDate,
                                    endDate,
                                    codifications: [], // [{ stationId: Int, codification: Int }]
                                    sender: hasValue(campaign.contributorCode) ? parseInt(campaign.contributorCode) : undefined,
                                    receiver: getReceiver(),
                                    planningId,
                                    stationId,
                                }))
                            },
                        }],
                    },
                    exportMissingAnalysis.length ? {
                        name: i18n.missingAnalysis,
                        formats: [{
                            type: i18n.excelFile,
                            callback: () => {
                                dispatch(ExportAction.export(formatData([
                                    { ...exportMissingAnalysis[0], headers: keys(omit(exportMissingAnalysis[0], 'id')) },
                                    ...exportMissingAnalysis.slice(1),
                                ]), 'xlsx', `${i18n.missingAnalysis} ${getDate(startDate)} - ${getDate(endDate)} : [${qualitometer?.code ?? ''}] ${qualitometer?.name ?? ''}${city !== '' ? ` - ${city}` : ''}`))
                            },
                        }, {
                            type: i18n.csvFile,
                            callback: () => {
                                dispatch(ExportAction.export(formatData([
                                    { ...exportMissingAnalysis[0], headers: keys(omit(exportMissingAnalysis[0], 'id')) },
                                    ...exportMissingAnalysis.slice(1),
                                ]), 'csv', `${i18n.missingAnalysis} ${getDate(startDate)} - ${getDate(endDate)} : [${qualitometer?.code ?? ''}] ${qualitometer?.name ?? ''}${city !== '' ? ` - ${city}` : ''}`))
                            },
                        }, {
                            type: i18n.EDILABODAI,
                            callback: () => {
                                const lastFile = maxBy(edilaboFiles, 'updateDate')
                                const exportPath = lastFile ? lastFile.href.split('EXPORT/EDILABO/')[1].replace(lastFile.label, '') : ''
                                const samplerCode = hasValue(campaign.samplerCode) ? parseInt(campaign.samplerCode) : undefined
                                const recipientCode = hasValue(campaign.recipientCode) ? parseInt(campaign.recipientCode) : undefined
                                const getReceiver = () => {
                                    switch (campaign.requestType) {
                                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.SAMPLE_REQUEST:
                                            return samplerCode
                                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.ANALYSIS_REQUEST:
                                            return recipientCode
                                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.MIXED_REQUEST:
                                            return recipientCode || samplerCode
                                        default:
                                            return undefined
                                    }
                                }
                                dispatch(ExportAction.exportEDILABOPlanning({
                                    campaignId: campaign.id,
                                    exportPath,
                                    requestName: formatedFileName(truncate(
                                        `DAI-MANQUANTS-${moment(startDate).format('DD/MM/YYYY').slice(0, 2)}-${moment(endDate).format('DD/MM/YYYY').slice(0, 2)}-${moment(endDate).format('DD/MM/YYYY').slice(3)}${qualitometer?.code ? `-${qualitometer.code}` : ''}`,
                                        {
                                            length: 34,
                                            omission: '',
                                        },
                                    )),
                                    startDate,
                                    endDate,
                                    codifications: [], // [{ stationId: Int, codification: Int }]
                                    sender: hasValue(campaign.contributorCode) ? parseInt(campaign.contributorCode) : undefined,
                                    receiver: getReceiver(),
                                    planningId,
                                    stationId,
                                    parameterIds: exportMissingAnalysis.map(({ id }) => id),
                                }))
                            },
                        }],
                    } : undefined,
                ])}
            />
            <OperationPCStepper
                isOpen={openModalOperationCreation}
                onClose={() => setOpenModalOperationCreation(false)}
                creationFromCampaignTracking
                planning={plannings.find(({ id }) => id === planningId)}
                parametersPlan={newParametersPlan}
            />
            <AnalysisStepper
                isOpen={!isNil(analysisStepper)}
                onClose={() => setAnalysisStepper()}
                operation={analysisStepper?.operation}
                sampleId={analysisStepper?.sampleId}
                defaultAnalysis={analysisStepper?.defaultAnalysis}
                onSaved={() => {
                    // même comportement que la création d'une opération depuis le suivi : on ouvre les analyses de l'opération
                    const { qualitometer: operationStationId, id: operationId } = analysisStepper?.operation ?? {}
                    dispatch(push(`/station/quality/${operationStationId}/operation/${operationId}?tab=${ANALYSIS}`))
                }}
            />
        </>
    )
}

PopinOperation.propTypes = {
    isOpen: PropTypes.bool,
    closePopin: PropTypes.func,
    plannings: PropTypes.arrayOf(PropTypes.shape({})),
    planningsProgress: PropTypes.arrayOf(PropTypes.shape({})),
    stationId: PropTypes.number,
    planningId: PropTypes.number,
    campaign: campaignShape,
}

const TableStation = ({
    startDate,
    endDate,
    planning = {},
    planningProgress = {},
    campaign,
    campaignStations,
}) => {
    const dispatch = useDispatch()

    const {
        qualitometers,
        citiesIndex,
        contributors,
        accountUser,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        citiesIndex: store.CityReducer.citiesIndex,
        accountUser: store.AccountReducer.accountUser,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const indexedQualitometers = useListIndexed(qualitometers, 'id')

    const generalShowInseeCode = useApplicationSetting(SHOW_INSEE_CODE, setting => setting ? parseInt(setting) : true)
    const showInseeCode = useAccountSetting(SHOW_INSEE_CODE, setting => setting ? parseInt(setting) : generalShowInseeCode)

    const {
        value: isOpen,
        setTrue: openPopin,
        setFalse: closePopin,
    } = useBoolean(false)
    const [selectedCell, setSelectedCell] = useState() // { stationId, planningId }

    const listStations = campaignStations.filter(cs => indexedQualitometers[cs.stationId] && planningProgress.stationsProgress.find(s => s.id === cs.stationId)).map(({ stationId }) => stationId)

    const completedStation = listStations.filter(id => planningProgress.stationsProgress.find(s => s.id === id).missingAnalysis.length === 0).length

    const producer = authorizeContributors(contributors, accountUser, planning.producer).find(({ id }) => id === planning.producer)

    const row = [{
        ...listStations.reduce((acc, id) => {
            const sp = planningProgress.stationsProgress.find(s => s.id === id)
            const nbNeededParameters = sp?.neededAnalysis ?? planning.parametersPlan.length
            acc[id] = {
                value: isNil(sp) ? '' : `${nbNeededParameters - sp.missingAnalysis.length}/${nbNeededParameters}`,
                color: isNil(sp) && PASTEL_COLOR.white || sp.missingAnalysis.length === 0 && PASTEL_COLOR.green || !sp.hasOperation && PASTEL_COLOR.red || PASTEL_COLOR.orange,
                onClick: isNil(sp) ? undefined : () => {
                    setSelectedCell({ stationId: id, planningId: planning.id })
                    openPopin()
                },
            }
            return acc
        }, {}),
    }]

    const headers = [
        ...orderBy(listStations, [
            id => {
                const sp = planningProgress.stationsProgress.find(s => s.id === id)
                const nbNeededParameters = sp?.neededAnalysis ?? planning.parametersPlan.length
                const nbMissing = sp?.missingAnalysis.length ?? 0
                if (nbMissing === 0) return 3
                if (nbMissing < nbNeededParameters) return 0
                return sp?.hasOperation ? 1 : 2
            },
            id => {
                const sp = planningProgress.stationsProgress.find(s => s.id === id)
                const nbNeededParameters = sp?.neededAnalysis ?? planning.parametersPlan.length
                return nbNeededParameters === 0 ? 1 : (sp?.missingAnalysis.length ?? 0) / nbNeededParameters
            },
        ], ['asc', 'asc']).map(id => {
            const qualito = indexedQualitometers[id]
            return {
                key: `${id}`,
                maxWidth: 150,
                value: (
                    <Stack>
                        {qualito?.code ?? ''}
                        <Typography>{qualito?.townCode ? citiesIndex[qualito.townCode]?.name : ''}</Typography>
                        <Typography sx={{ fontWeight: 'normal', fontSize: 12 }}>{qualito?.name ?? ''}</Typography>
                    </Stack>
                ),
                tooltip: (
                    <Stack>
                        <Typography>{showInseeCode ? citiesIndex[qualito.townCode]?.labelWithCode : citiesIndex[qualito.townCode]?.name}</Typography>
                        <Typography>{qualito?.name ?? ''}</Typography>
                    </Stack>
                ),
                onClick: () => dispatch(push(`/station/quality/${id}/suiviPC?campaign=${campaign.id}&startDate=${startDate}${endDate ? `&endDate=${endDate}` : ''}`)),
            }
        }),
    ]

    return (
        <>
            <CardTable
                title={`${getPlanningPeriodTitle(planning.startDate, planning.endDate)}${producer ? ` - ${producer.name}` : ''} ${producer?.mnemonique ? `[${producer.mnemonique}]` : ''}`}
                actions={[<CampaignProgress key='progress' done={completedStation} total={listStations.length} />]}
                rows={row}
                headers={headers}
                hideNbElements

                defaultSort={{ column: 'planning', direction: SORT.ASC }}
                rowsPerPageOptions={nbPerPageLabel}
            />
            <PopinOperation
                isOpen={isOpen}
                closePopin={closePopin}
                plannings={[planning]}
                planningsProgress={[planningProgress]}
                stationId={selectedCell?.stationId}
                planningId={selectedCell?.planningId}
                campaign={campaign}
            />
        </>
    )
}

TableStation.propTypes = {
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    planning: PropTypes.shape({}),
    planningProgress: PropTypes.shape({
        id: PropTypes.number,
        stationsProgress: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            missingAnalysis: PropTypes.arrayOf(PropTypes.shape({})),
        })),
    }),
    campaign: campaignShape,
    campaignStations: PropTypes.arrayOf(PropTypes.shape({})),
}

const CartoStation = ({
    campaignStations,
}) => {
    const {
        qualitometers,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
    }), shallowEqual)

    const stations = campaignStations.map(cs => {
        const qualitometer = qualitometers.find(q => q.id == cs.stationId)
        if (!qualitometer) {
            return
        }
        return {
            ...qualitometer,
            markerIcon: getMarkerIcon('quality'),
        }
    }).filter(s => !!s)

    return (
        <CartographyPanel
            layers={['STATIONS_POINTS']}
            componentType={'quality'}
            stationsPoints={stations}
            stationsPanelTitle={i18n.quality}
            height={750}
        />
    )
}

CartoStation.propTypes = {
    campaignStations: PropTypes.arrayOf(PropTypes.shape({})),
}

const ExportModal = ({
    isOpen = false,
    close = () => {},

    plannings = [],
    planningsProgress = [],
    campaignStations,
}) => {
    const dispatch = useDispatch()

    const {
        qualitometers,
        supports,
        fractions,
        units,
        parameters,
        cities,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        supports: store.SupportReducer.supports,
        fractions: store.FractionReducer.fractions,
        units: store.UnitReducer.units,
        parameters: store.ParameterReducer.parameters,
        cities: store.CityReducer.cities,
    }), shallowEqual)

    const indexedQualitometers = useListIndexed(qualitometers, 'id')
    const indexedCities = useListIndexed(cities, 'id')

    const onExportTable = (exportFormat) => {
        const listStations = campaignStations.filter(cs => indexedQualitometers[cs.stationId]).map(cs => cs.stationId)

        const rows = plannings.map(cp => {
            const { stationsProgress = [] } = planningsProgress.find(pp => pp.id === cp.id) ?? {}

            const listStationsByPlanning = campaignStations.filter(cs => indexedQualitometers[cs.stationId] && stationsProgress?.find(s => s.id === cs.stationId)).map(({ stationId }) => stationId)

            const completedStation = stationsProgress.reduce((nb, sp) => sp.missingAnalysis.length === 0 ? nb + 1 : nb, 0)
            return {
                planning: `${getDate(cp.startDate)} - ${getDate(cp.endDate)}`,
                executed: `${completedStation}/${listStationsByPlanning.length}`,
                ...listStations.reduce((acc, id) => {
                    const sp = stationsProgress.find(s => s.id === id)
                    const nbNeededParameters = sp?.neededAnalysis || cp.parametersPlan.length
                    acc[id] = {
                        value: isNil(sp) ? '' : `${nbNeededParameters - sp.missingAnalysis.length}/${nbNeededParameters}`,
                        color: isNil(sp) && PASTEL_COLOR.white || sp.missingAnalysis.length === 0 && PASTEL_COLOR.green || sp.missingAnalysis.length === nbNeededParameters && PASTEL_COLOR.red || PASTEL_COLOR.orange,
                    }
                    return acc
                }, {}),
            }
        })

        const headers = [
            'planning',
            'executed',
            ...listStations.map(id => `${id}`),
        ]

        const customHeaders = [
            'planning',
            'executed',
            ...listStations.map(id => {
                const qualito = indexedQualitometers[id]
                const city = qualito?.townCode ? indexedCities[qualito?.townCode]?.name || '' : ''
                return `[${qualito?.code ?? ''}] ${qualito?.name ?? ''}${city !== '' ? ` - ${city}` : ''}`
            }),
        ]

        const dataWithHeaders = rows.length ? [
            { ...rows[0], headers, customHeaders },
            ...rows.slice(1),
        ] : []

        dispatch(ExportAction.export(formatData(dataWithHeaders), exportFormat, i18n.tracking))
    }

    const onExportResultsMissing = (exportFormat) => {
        const rows = plannings.map(cp => {
            const { stationsProgress = [] } = planningsProgress.find(pp => pp.id === cp.id) ?? {}

            return stationsProgress.map(sp => sp.missingAnalysis.map(ma => ({
                stationCode: { value: indexedQualitometers[sp.id]?.code, cellType: 'string' },
                city: indexedQualitometers[sp.id]?.townCode ? indexedCities[indexedQualitometers[sp.id]?.townCode]?.name : undefined,
                stationName: indexedQualitometers[sp.id]?.name,
                startDate: getDate(cp.startDate),
                endDate: getDate(cp.endDate),
                parameterCode: ma.parameter,
                parameter: getLabel(parameters, ma.parameter),
                codeUnit: ma.unit,
                unit: getLabel(units, ma.unit),
                supportCode: ma.support,
                support: getLabel(supports, ma.support),
                fractionCode: ma.fraction,
                fraction: getLabel(fractions, ma.fraction),
                place: getLocalizationLabel(ma.localization),
            })))
        })

        const flattenRows = flattenDeep(rows)

        const dataWithHeaders = flattenRows.length ? [
            { ...flattenRows[0], headers: keys(flattenRows[0]) },
            ...flattenRows.slice(1),
        ] : []

        dispatch(ExportAction.export(formatData(dataWithHeaders), exportFormat, i18n.tracking))
    }

    return (
        <ExportFileModal
            open={isOpen}
            onClose={close}
            data={[
                {
                    name: i18n.resultsTable,
                    formats: [{
                        type: i18n.excelFile,
                        callback: () => onExportTable('xlsx'),
                    }, {
                        type: i18n.csvFile,
                        callback: () => onExportTable('csv'),
                    }],
                },
                {
                    name: 'Résultat manquant',
                    formats: [{
                        type: i18n.excelFile,
                        callback: () => onExportResultsMissing('xlsx'),
                    }, {
                        type: i18n.csvFile,
                        callback: () => onExportResultsMissing('csv'),
                    }],
                },
            ]}
        />
    )
}

ExportModal.propTypes = {
    isOpen: PropTypes.bool,
    close: PropTypes.func,
    plannings: PropTypes.arrayOf(PropTypes.shape({})),
    planningsProgress: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        stationsProgress: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            missingAnalysis: PropTypes.arrayOf(PropTypes.shape({})),
        })),
    })),
    campaignStations: PropTypes.arrayOf(PropTypes.shape({})),
}

const CampaignTrackingOperation = ({
    planningsProgress = [],
    context,
}) => {
    const dispatch = useDispatch()
    const {
        campaign,
        campaignStations,
        campaignParameters,
        campaignPlannings,
    } = context

    const {
        qualitometers,
        accountUser,
        contributors,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        accountUser: store.AccountReducer.accountUser,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const {
        value: isOpen,
        setTrue: openImport,
        setFalse: closePopin,
    } = useBoolean(false)

    const {
        value: isExportOpen,
        setFalse: closeExport,
        setTrue: openExport,
    } = useBoolean(false)

    const [searchValue, setSearchValue] = useState()
    const [selectedProducer, setSelectedProducer] = useState()

    const startDate = moment(campaign.beginningApplication, 'DD/MM/YYYY').valueOf()
    const endDate = hasValue(campaign.endingApplication) ? moment(campaign.endingApplication, 'DD/MM/YYYY').valueOf() : undefined

    const plannings = useMemo(() => {
        if (campaignPlannings.length > 0) {
            return campaignPlannings.map(cP => {
                const formattedCampaignStations = compact(cP.stationsPlan.map(campaignStationId => campaignStations.find(station => station.id === campaignStationId)))
                const formattedStations = compact(formattedCampaignStations
                    .map(({ stationId }) => qualitometers.find(({ id }) => id === stationId)),
                ).map(station => ({
                    ...station,
                    _normalizedSearchString: values(pick(station, ['name', 'townCode'])).map(s => normalizeString(s)),
                }))
                const filteredStations = hybridSearch(formattedStations, normalizeString(searchValue))
                return ({
                    ...cP,
                    stationsPlan: filteredStations.map(({ id }) => id),
                    parametersPlan: campaignParameters.filter(cParam => includes(cP.parametersPlan, cParam.id)),
                })
            })
        }
        const formattedStations = compact(campaignStations
            .map(({ stationId }) => qualitometers.find(({ id }) => id === stationId)),
        ).map(station => ({
            ...station,
            _normalizedSearchString: values(pick(station, ['name', 'townCode'])).map(s => normalizeString(s)),
        }))
        const filteredStations = hybridSearch(formattedStations, normalizeString(searchValue))
        return [{
            campaignId: campaign.id,
            id: -1,
            startDate,
            endDate,
            parametersPlan: campaignParameters,
            stationsPlan: filteredStations.map(({ id }) => id),
        }]
    }, [campaign.id, campaignParameters, campaignPlannings, campaignStations, endDate, startDate, qualitometers, searchValue])

    const filteredPlannings = useMemo(() => plannings.filter(({ stationsPlan, producer }) => (
        !isEmpty(stationsPlan) && (
            selectedProducer === NOT_SPECIFIED_PRODUCER ? isUndefined(producer) : isUndefined(selectedProducer) || selectedProducer === producer
        )
    )), [plannings, selectedProducer])

    useActions(() => {
        return {
            import: openImport,
            exportList: [{
                onClick: openExport,
                label: i18n.excel,
            }],
        }
    }, [])

    const groupedPlannings = groupBy(filteredPlannings, p => moment(p.startDate).month())

    return (
        <Grid container sx={{ padding: '5 10' }} spacing={2}>
            <Grid size={12}>
                <SimpleTabList
                    defaultTab={LIST}
                    tabs={[
                        {
                            constant: LIST,
                            label: i18n.table,
                            icon: 'list',
                        },
                        {
                            constant: CARTO,
                            label: i18n.map,
                            icon: 'map',
                        },
                    ]}
                    headerComponent={(
                        <Card>
                            <CardTitle title={getCampaignPeriodTitle(campaign.beginningApplication, campaign.endingApplication)} />
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid size={6}>
                                        <Input
                                            title={i18n.search}
                                            value={searchValue}
                                            onChange={setSearchValue}
                                        />
                                    </Grid>
                                    <Grid size={'grow'}>
                                        <Select
                                            label={i18n.completion}
                                            options={[
                                                { name: i18n.notSpecified, code: NOT_SPECIFIED_PRODUCER },
                                                ...authorizeContributors(contributors, accountUser, selectedProducer).filter(({ id }) => includes(uniq(plannings.map(({ producer }) => producer)).map(code => parseInt(code)), id)),
                                            ]}
                                            noSort
                                            value={selectedProducer}
                                            onChange={setSelectedProducer}
                                        />
                                    </Grid>
                                    <Grid offset={11} size={1}>
                                        <Button
                                            variant={'contained'}
                                            fullWidth
                                            onClick={() => {
                                                setSearchValue()
                                                setSelectedProducer()
                                            }}
                                        >
                                            {i18n.reinit}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    )}
                >
                    {
                        tab => (
                            <>
                                {tab === LIST && (
                                    <Stack spacing={2}>
                                        {isEmpty(groupedPlannings) ?
                                            <NoDataPanel />
                                            :
                                            keys(groupedPlannings).map((month, i) => (
                                                <Accordion key={i} defaultExpanded={moment().month() === parseInt(month)}>
                                                    <AccordionTitle
                                                        title={capitalize(moment().month(month).format('MMMM'))}
                                                        subTitle={`${groupedPlannings[month].length} ${getI18nTitleDataLength(i18n.planning, i18n.plannings, groupedPlannings[month].length)}`}
                                                    />
                                                    <Stack spacing={2} padding={1}>
                                                        {orderBy(groupedPlannings[month], 'startDate', 'asc').map((p, j) => (
                                                            <TableStation
                                                                key={j}
                                                                startDate={startDate}
                                                                endDate={endDate}
                                                                planning={p}
                                                                planningProgress={planningsProgress.find(pP => pP.id === p.id)}
                                                                campaign={campaign}
                                                                campaignStations={campaignStations.filter(cS => includes(p.stationsPlan, cS.stationId))}
                                                            />
                                                        ))}
                                                    </Stack>
                                                </Accordion>
                                            ))
                                        }
                                    </Stack>
                                )}
                                {tab === CARTO && (<CartoStation campaignStations={campaignStations} />)}
                            </>
                        )
                    }
                </SimpleTabList>
                <ImportXmlQualityPopup
                    campaignId={campaign.id}
                    callbackImport={() => dispatch(CampaignAction.fetchQualityCampaignOperation(campaign.id))}
                    stations={campaignStations.map(({ stationId }) => qualitometers.find(({ id }) => id === stationId)?.code).filter(c => !!c)}
                    isOpen={isOpen}
                    onClose={closePopin}
                />
                <ExportModal
                    isOpen={isExportOpen}
                    close={closeExport}

                    plannings={plannings}
                    planningsProgress={planningsProgress}
                    campaignStations={campaignStations}
                />
            </Grid>
        </Grid>
    )
}

CampaignTrackingOperation.propTypes = {
    planningsProgress: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        stationsProgress: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            missingAnalysis: PropTypes.arrayOf(PropTypes.shape({})),
        })),
    })),
    context: PropTypes.shape({
        campaign: campaignShape,
        campaignStations: PropTypes.arrayOf(PropTypes.shape({})),
        campaignParameters: PropTypes.arrayOf(PropTypes.shape({})),
        campaignPlannings: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
}

export default CampaignTrackingOperation
